import { type FormEvent, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { Button } from '../components/Button';
import { ApiError } from '../api/client';

export function SignUp() {
  const { signUp, actor } = useAuth();
  const navigate = useNavigate();
  const guestName = actor?.kind === 'guest' ? actor.guest.displayName : null;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState(guestName ?? '');
  const [mergeGuest, setMergeGuest] = useState<boolean>(!!guestName);
  const [err, setErr] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setErr(null);
    setSubmitting(true);
    try {
      await signUp(email, password, displayName.trim(), mergeGuest);
      navigate('/events');
    } catch (e) {
      setErr(e instanceof ApiError ? e.message : 'Sign up failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container">
      <form onSubmit={onSubmit} className="card stack">
        <h1>Create account</h1>
        {err && <div className="error">{err}</div>}
        <div>
          <label htmlFor="displayName">Display name</label>
          <input id="displayName" required minLength={1} maxLength={60} value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
        </div>
        <div>
          <label htmlFor="email">Email</label>
          <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div>
          <label htmlFor="password">Password (8+ chars)</label>
          <input id="password" type="password" autoComplete="new-password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {guestName && (
          <label style={{ display: 'flex', gap: 8, alignItems: 'center', fontWeight: 400 }}>
            <input type="checkbox" checked={mergeGuest} onChange={(e) => setMergeGuest(e.target.checked)} />
            Keep my previous scores entered as <strong style={{ marginLeft: 4 }}>{guestName}</strong>
          </label>
        )}
        <Button type="submit" block disabled={submitting}>{submitting ? 'Creating…' : 'Create account'}</Button>
        <p className="muted" style={{ textAlign: 'center' }}>
          Already have one? <Link to="/signin">Sign in</Link>
        </p>
      </form>
    </div>
  );
}
